const NotificationEntity = (backClient) => ({
  index: async () => {
    const { data } = await backClient.get("/api/notifications")
    return data
  },
})

export default NotificationEntity
